module.exports = __webpack_public_path__ + "static/media/spinner.44271f65.gif";